// Handshake with the website embedding the player in an iframe.
//
// Registered at application start (side-effect import in src/index.js), not at
// player mount: the parent posts its init message around iframe load, while the
// embed page is still code-splitting and fetching the recording. postMessage is
// not queued, so a listener registered any later misses the handshake for good.

let parentOrigin = null;
let pendingEvent = null;

const isEmbedded = !!window.parent && window.parent !== window;

const flush = () => {
  if (!parentOrigin || !pendingEvent)
    return;
  window.parent.postMessage(pendingEvent, parentOrigin);
  pendingEvent = null;
};

if (isEmbedded) {
  window.addEventListener("message", (event) => {
    if (event.source !== window.parent)
      return;

    const data = event.data;

    if (data?.type !== "slidespiel.player.init" || data?.version !== 1)
      return;

    // Browser-verified origin of the embedding website.
    parentOrigin = event.origin;
    flush();
  });
}

// Sends the event, or holds it until the parent handshake arrives.
export const postPlayerEvent = (payload) => {
  if (!isEmbedded)
    return;
  pendingEvent = { type: "slidespiel.player.event", version: 1, ...payload };
  flush();
};
